import type { FallbackProps } from "./ErrorBoundary";
import { useRouteError } from "react-router-dom";
import FailureStatePage from "./FailureStatePage";

export function FailureState({
  error,
  homepageUrl,
  isConsoleErrorEnabled = true
}: FallbackProps) {
  const routeError = useRouteError();
  const errorToUse = error || (routeError as Error);

  return (
    <FailureStatePage
      errorToUse={errorToUse}
      homepageUrl={homepageUrl}
      isConsoleErrorEnabled={isConsoleErrorEnabled}
    />
  );
}

export default FailureState;
